import React from "react";
import "./heroanim.css";
const Heroanim = () => {
  return (
    <div className="container">
      <div className="infinitehorizonscroll">
        <div className="infinitehorizon1">
          <span>
            UI Designer UI Designer UI Designer UI Designer UI Designer
          </span>
          <span>
            UI Designer UI Designer UI Designer UI Designer UI Designer
          </span>
        </div>
        <div className="infinitehorizon2">
          <span>
            Fullstack Developer Fullstack Developer Fullstack Developer
            Fullstack Developer
          </span>
          <span>
            Fullstack Developer Fullstack Developer Fullstack Developer
            Fullstack Developer
          </span>
        </div>
      </div>
    </div>
  );
};

export default Heroanim;
